module.exports = __webpack_public_path__ + "static/media/locationMap.71b30504.svg";